module.exports = __webpack_public_path__ + "img/mp3.5321b9ef.svg";